// ביקורות אמיתיות מפרופיל Google Business של QuickTor.
// מקור יחיד — מוצג באתר, ב-llms.txt ובסכמה (sameAs/hasMap). לעדכן ידנית כשנכנסות ביקורות חדשות.
// אין להוסיף כאן ביקורת שלא מופיעה בפועל בגוגל.
// בדיקה אחרונה מול הפרופיל: 2026-10-09 (עדיין 5.0, 2 ביקורות)

export const GOOGLE_PLACE_ID = "ChIJEQhlgv7fqIERrgfaDJibKV8";
export const GOOGLE_MAPS_CID = "6857182985001240494";

export const GOOGLE_PROFILE_URL = `https://maps.google.com/?cid=${GOOGLE_MAPS_CID}`;

export const GOOGLE_RATING = {
  ratingValue: "5.0",
  reviewCount: 2,
  checkedAt: "2026-09-24",
};

// avatar: נתיב לתמונה תחת public/ (רק באישור הממליצה), או null — אז מוצגת האות הראשונה כמו בגוגל.
export const GOOGLE_REVIEWS = [
  {
    author: "אסתי ס.",
    rating: 5,
    avatar: null,
    text: "רוצה להמליץ בחום על דין! מעבר לשירות לקוחות פשוט מעולה, קיבלתי גם עזרה טכנית מקצועית, מהירה וסבלנית. כל שאלה או תקלה קיבלו מענה עד הסוף, עם המון רצון לעזור ויחס אישי. שירות באמת יוצא מן הכלל, אין ספק שזה לא מובן מאליו ❤",
  },
  {
    author: "אתי ג.",
    rating: 5,
    avatar: null,
    text: "אין על דין והאפליקציה זה ממש עוזר ודין עוזר בכל דבר זמין תמיד. אז יאללה תיכנסו ולא תצטערו הכל במקום אחד.",
  },
];
